import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography, Button } from "@mui/material";
import DragAndDrop from "../components/DragAndDrop";
import TextInput from "../reusableComponents/components/generics/TextInput";
import { Field, FormSpy } from "react-final-form";
import {
  documentDelete,
  documentFileSearch,
  documentTemplate,
  documentUpload,
  documentsSearch,
  loginCnss,
} from "../action";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginLeft: "auto",
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "1rem",
}));
function PolicyholderUploadDocs({ phId, setDocumentDetails }) {
  const { t } = useTranslation();
  const [uploadProgress, setUploadProgress] = useState({});
  const [validatationErrors, setValidationErrors] = useState(false);
  const [files, setFiles] = useState({});
  const [documents, setDocuments] = useState([]);
  const dispatch = useDispatch();
  const fileData = useSelector((state) => state.profileReducer);
  const GedTokenDocs = localStorage.getItem("GED_token");

  useEffect(() => {
    if (GedTokenDocs) {
      dispatch(documentTemplate("Employer Registration"));
      if (phId) {
        dispatch(documentFileSearch(phId));
        dispatch(documentsSearch(phId));
      }
    }
  }, [GedTokenDocs, dispatch, phId]);

  useEffect(() => {
    if (fileData.uploadedData?.documentId || fileData.deletedData) {
      dispatch(documentsSearch(phId));
    }
  }, [fileData.uploadedData?.documentId, fileData.deletedData, dispatch, phId]);
  useEffect(() => {
    if (fileData?.documentData) {
      const hasDocuments = fileData?.documentData.length;
      setDocumentDetails(hasDocuments);
    }
  }, [fileData?.documentData]);
  const initialDocuments = [];
  useEffect(() => {
    if (fileData?.documentData) {
      setDocumentDetails(fileData.documentData.length);
    }
  }, [fileData?.documentData, setDocumentDetails]);

  const handleAddDocument = () => {
    setDocuments((prevDocuments) => [
      ...prevDocuments,
      { id: `file${prevDocuments.length + 1}`, file: null },
    ]);
  };

  const handleFileChange2 = (id, newFile, inputData) => {
    if (!!inputData) {
      setDocuments((prevDocuments) =>
        prevDocuments.map((doc) =>
          doc.id === id ? { ...doc, file: null } : doc
        )
      );
      dispatch(documentUpload(newFile, fileData?.fileData?.[0]?.id, inputData));
      setDocuments([]);
    } else {
      setValidationErrors(true);
    }
    // setDocuments((prevDocuments) =>
    //   prevDocuments.map((doc) => (doc.id === id ? { ...doc, file: null } : doc))
    // );
    // console.log('newFile[0]',newFile,"inputdata",fileData?.fileData?.[0]?.id, inputData);

    // dispatch(
    //   documentUpload(newFile, fileData?.fileData?.[0]?.id, inputData)
    // );
    // setDocuments([]);
  };

  const handleDrop2 = (id, event, inputData) => {
    if (!!inputData) {
      event.preventDefault();
      const droppedFiles = event.dataTransfer.files;
      if (droppedFiles.length > 0) {
        const newFiles = Array.from(droppedFiles);
        // setDocuments((prevDocuments) =>
        //   prevDocuments.map((doc) => (doc.id === id ? { ...doc, file: null } : doc))
        // );
        dispatch(
          documentUpload(newFiles[0], fileData?.fileData?.[0]?.id, inputData)
        );
        setDocuments([]);
      }
    } else {
      setValidationErrors(true);
    }
  };

  const handleFileRemove2 = (id) => {
    setDocuments((prevDocuments) =>
      prevDocuments.map((doc) => (doc.id === id ? { ...doc, file: null } : doc))
    );
    dispatch(documentDelete(id));
    setTimeout(() => {
      dispatch(documentsSearch(phId)); // Re-fetch documents after deletion
    }, 500);
  };

  const handleUploadProgress2 = (id, progress) => {
    setDocuments((prevDocuments) =>
      prevDocuments.map((doc) =>
        doc.id === id ? { ...doc, uploadProgress: progress } : doc
      )
    );
  };

  const handleFileChange = (id, newFile) => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [id]: newFile,
    }));
    dispatch(documentUpload(newFile, fileData?.fileData?.[0]?.id, id));
  };

  const handleDrop = (id, event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      setFiles((prevFiles) => ({ ...prevFiles, [id]: newFiles[0] }));
      dispatch(documentUpload(newFiles[0], fileData?.fileData?.[0]?.id, id));
    }
  };

  const handleFileRemove = (id) => {
    setFiles((prevFiles) => {
      const updatedFiles = { ...prevFiles };
      delete updatedFiles[id];
      return updatedFiles;
    });
    dispatch(documentDelete(id));
    setTimeout(() => {
      dispatch(documentsSearch(phId)); // Re-fetch documents after deletion
    }, 500);
  };

  const handleUploadProgress = (id, progress) => {
    setUploadProgress((prevProgress) => ({
      ...prevProgress,
      [id]: progress,
    }));
  };

  const additionalDocuments = [];

  if (fileData?.documentData && fileData?.templateData) {
    fileData.documentData.forEach((document) => {
      const matchingTemplate = fileData.templateData.find(
        (template) => template.name === document?.documentName
      );
      if (matchingTemplate) {
        initialDocuments.push({
          ...document,
          templateId: matchingTemplate.id,
        });
      } else {
        additionalDocuments.push(document);
      }
    });

    fileData.templateData.forEach((template) => {
      const matchingDocument = fileData.documentData.find(
        (document) => document.documentName === template.name
      );
      if (!matchingDocument) {
        initialDocuments.push(template);
      }
    });
  }
  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <StyledPaper>
            <StyledPaperHeader container alignItems="center" direction="row">
              <Grid item alignItems="center">
                <Typography variant="h6">{t("Upload Documents")}</Typography>
              </Grid>
            </StyledPaperHeader>
            <StyledGrid container alignItems="start" direction="row">
              {initialDocuments &&
                initialDocuments.map((document) => (
                  <Grid item xs={4} className="common-input" key={document?.id}>
                    <Typography variant="body1">
                      {document?.documentName
                        ? t(document?.documentName)
                        : t(document.name)}
                    </Typography>
                    <DragAndDrop
                      id={document?.documentId || document.name}
                      file={document?.documentPath || document.file}
                      onFileChange={(newFile) =>
                        handleFileChange(
                          document?.documentId || document.name,
                          newFile
                        )
                      }
                      handleDrop={(newFile) =>
                        handleDrop(
                          document?.documentId || document.name,
                          newFile
                        )
                      }
                      onFileRemove={() =>
                        handleFileRemove(document?.id || document.name)
                      }
                      uploadProgress={
                        uploadProgress[
                          document?.documentId
                            ? document?.documentId
                            : document.name
                        ] || 0
                      }
                      onUploadProgress={(progress) =>
                        handleUploadProgress(
                          document?.documentId || document.name,
                          progress
                        )
                      }
                      width="100%"
                      height="auto"
                    />
                  </Grid>
                ))}
            </StyledGrid>
          </StyledPaper>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <StyledPaper>
            <StyledPaperHeader container alignItems="center" direction="row">
              <Grid item xs={12} alignItems="center" display="flex">
                <Typography variant="h6">{t("Other Documents")}</Typography>
                <StyledButton
                  onClick={handleAddDocument}
                  variant="contained"
                  disabled={documents.length < 1 ? false : true}
                >
                  {t("Add")}
                </StyledButton>
              </Grid>
            </StyledPaperHeader>
            <Grid container className="m-2">
              {additionalDocuments &&
                additionalDocuments.map((document, index) => (
                  <Grid
                    key={document.id || index}
                    item
                    xs={4}
                    className="common-input"
                  >
                    <Typography variant="body1">
                      {document?.documentName}
                    </Typography>
                    <FormSpy subscription={{ values: true }}>
                      {({ values }) => (
                        <DragAndDrop
                          id={`additionalDocument${document?.id || index}`}
                          file={document?.documentPath}
                          onFileChange={(newFile) =>
                            handleFileChange2(
                              document.id || index,
                              newFile,
                              values[
                                `additionalDocument${document?.id || index}`
                              ]
                            )
                          }
                          handleDrop={(newFile) =>
                            handleDrop2(document.id || index, newFile)
                          }
                          onFileRemove={() =>
                            handleFileRemove2(document.id || index)
                          }
                          uploadProgress={document.uploadProgress || 0}
                          onUploadProgress={(progress) =>
                            handleUploadProgress2(
                              document.id || index,
                              progress
                            )
                          }
                          width="100%"
                          height="auto"
                        />
                      )}
                    </FormSpy>
                  </Grid>
                ))}
              {documents.map((document) => (
                <Grid
                  key={document?.id}
                  item
                  xs={4}
                  className="common-input my-2"
                >
                  <Field
                    name={`document${document.id ? document?.id : 1}`}
                    component={TextInput}
                    label={`Document ${document.id ? document?.id : 1}`}
                    type="text"
                  />
                  <FormSpy subscription={{ values: true }}>
                    {({ values }) => {
                      return (
                        <>
                          {!!validatationErrors &&
                            !values[
                              `document${document.id ? document.id : 1}`
                            ] && (
                              <Typography variant="span" color="red">
                                {t("enterTheDocumentName")}{" "}
                              </Typography>
                            )}
                          <DragAndDrop
                            id={`document${document.id}`}
                            file={document.file}
                            onFileChange={(newFile) =>
                              handleFileChange2(
                                document.id,
                                newFile,
                                values[
                                  `document${document.id ? document.id : 1}`
                                ]
                              )
                            }
                            handleDrop={(newFile) =>
                              handleDrop2(document.id, newFile)
                            }
                            onFileRemove={() => handleFileRemove2(document.id)}
                            uploadProgress={document.uploadProgress || 0}
                            onUploadProgress={(progress) =>
                              handleUploadProgress2(document.id, progress)
                            }
                            width="100%"
                            height="auto"
                          />
                        </>
                      );
                    }}
                  </FormSpy>
                </Grid>
              ))}
            </Grid>
          </StyledPaper>
        </Grid>
      </Grid>
    </div>
  );
}

export default PolicyholderUploadDocs;
